<template>
  <list-item :title="event.title" :action-url="actionUrlWithParams" :color-index="colorIndexForType('event')">
    <template #pre-title>
      <div class="date-and-time d-flex flex-wrap justify-content-between">
        <template v-if="onlyShowStartAndEndDates">
          <span>
            {{ i18n.l('time.formats.date_with_spaces', event.startAt) }}
            &mdash; {{ i18n.l('time.formats.date_with_spaces', event.endAt) }}
          </span>
        </template>
        <template v-else>
          <span>
            {{ i18n.l('time.formats.date_with_spaces', event.startAt) }}
          </span>
          <span>
            {{ i18n.l('time.formats.time_only', event.startAt) }}
            <template v-if="showEndTime">
              &mdash; {{ i18n.l('time.formats.time_only', event.endAt) }}
            </template>
            {{ event.startTz }}
          </span>
        </template>
      </div>
    </template>
    <template #content>
      <div class="content">
        <location-details v-if="event.location" class="mb5" :location="event.location" :venue="event.locationVenue"
                          :hide-exact-location="event.hiddenAddress" />
        <virtual-event-details-with-icon v-if="event.virtual" class="mb5" />
      </div>
    </template>
    <template #action-button-text>
      {{ i18n.t('public.events.rsvp') }}
    </template>
  </list-item>
</template>

<script>
import ListItem from './list-item'
import LocationDetails from '../components/location-details'
import VirtualEventDetailsWithIcon from '../components/virtual-event-details-with-icon'
import { sharedEventListItemMixin } from './shared-event-list-item'
import { actionUrlWithParamsMixin } from './action-url-with-params'
import { isMultiDayEvent } from '../helpers/event'
import isPresent from '../helpers/is-present'

export default {
  components: { ListItem, LocationDetails, VirtualEventDetailsWithIcon},

  mixins: [ actionUrlWithParamsMixin, sharedEventListItemMixin ],

  computed: {
    onlyShowStartAndEndDates() {
      return isMultiDayEvent(this.event)
    },
    showEndTime() {
      return isPresent(this.event.endAt)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-and-time {
  font-weight: bold;
  margin-top: 8px;
  font-size: 16px;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

::v-deep(.detail-with-icon) {
  max-width: 100%;
}
</style>
